import { proxyCustomElement, HTMLElement, h } from '@stencil/core/internal/client';
import { s as snakeCaseToHumanReadable, e as formatDate, g as formatTimeSeconds } from './utils2.js';

const BusinessDocumentsOnFile = /*@__PURE__*/ proxyCustomElement(class BusinessDocumentsOnFile extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.documents = [];
    }
    render() {
        if (!this.documents.length) {
            return null;
        }
        return (h("div", null, h("div", { class: 'card' }, h("div", { class: 'card-body' }, h("h5", { class: 'card-title' }, "Documents Already on File"), h("div", { class: 'table-responsive' }, h("table", { class: 'table table-sm table-borderless' }, h("thead", { part: "table-head" }, h("tr", { part: 'table-head-row' }, h("th", { style: { width: '25%' }, part: "table-head-cell", scope: 'col' }, "File Name"), h("th", { style: { width: '25%' }, part: "table-head-cell", scope: 'col' }, "File Type"), h("th", { style: { width: '25%' }, part: "table-head-cell", scope: 'col' }, "Document Type"), h("th", { style: { width: '25%' }, part: "table-head-cell", scope: 'col' }, "Date Uploaded"))), h("tbody", { part: 'table-body' }, this.documents.sort((a, b) => a.document_type.localeCompare(b.document_type))
            .map((document, index) => {
            return (h("tr", { class: index === 0 ? 'border-bottom border-top' : 'border-bottom' }, h("td", { part: "table-cell" }, document.file_name), h("td", { part: "table-cell" }, document.file_type), h("td", { part: "table-cell" }, snakeCaseToHumanReadable(document.document_type)), h("td", { part: "table-cell" }, `${formatDate(document.created_at)} - ${formatTimeSeconds(document.created_at)}`)));
        })))))), h("hr", null)));
    }
}, [0, "justifi-business-documents-on-file", {
        "documents": [8]
    }]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["justifi-business-documents-on-file"];
    components.forEach(tagName => { switch (tagName) {
        case "justifi-business-documents-on-file":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, BusinessDocumentsOnFile);
            }
            break;
    } });
}
defineCustomElement();

export { BusinessDocumentsOnFile as B, defineCustomElement as d };
